import { z } from 'zod';
/** A calendar day, `YYYY-MM-DD`. */
export const isoDay = z.iso.date();
/** A moment with its offset, as the API sends timestamps. */
export const isoInstant = z.iso.datetime({ offset: true });
/** An ISO 3166-1 alpha-2 country, e.g. `DE`. */
export const CountryCode = z.string().regex(/^[A-Z]{2}$/);
//# sourceMappingURL=values.js.map